import Realization from './Realization'

const BusinessTripRealization = {
  namespaced: true,
  modules: {
    Realization: Realization
  },
  actions: {
    reset: (context, payload) => {
      context.dispatch('Realization/reset', payload)
    }
  }
}

export default BusinessTripRealization



// WEBPACK FOOTER //
// ./src/store/btrealization/index.js